export class Service {
    libelle: string;
    direction_id: string;
}
